import { playerMobileHeight } from 'styling/theme'

import { Theme } from 'styling/theme'
import { makeStyles } from '@material-ui/styles'

export const useStyles = makeStyles((theme: Theme) => ({
    videoWrapper: {
        position: 'relative',
        height: '0',
        paddingBottom: `${playerMobileHeight}%` /* Aspect ratio 16:9*/,
    },
    icon: {
        color: theme.colors.white,
    },
}))
